module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-BoldItalic.6f2fe4b.woff";